import { Pipe, PipeTransform } from '@angular/core';
import { Frequency } from '../models/frequency.model';
import { TrashServiceDetail, TrashServiceOptions } from '../models/service-details.model';
import { sortFrequency } from '../utils/sort-frequency';

@Pipe({
  name: 'adaptTrashServiceOptions',
  standalone: true,
})
export class AdaptTrashServiceOptionsPipe implements PipeTransform {
  public transform(value: { items: TrashServiceDetail[] } | null): TrashServiceOptions | null {
    if (value?.items?.length) {
      const alternativeSizes: { [key: number]: string } = {};
      const options = value.items;
      const optionsMatrix = new Map<string, TrashServiceDetail>();
      options.forEach((item) => {
        // key in a format: <trashSize>-<trashFrequency>-<trashExtraCount>
        const key = item.containerSize + '-' + item.frequency + '-' + item.extraContainersCount;
        optionsMatrix.set(key, item);
      });
      const sizeOptions: Set<{ size: number; desc: string }> = new Set();
      options.forEach((item) => {
        sizeOptions.add({ size: item.containerSize, desc: item.trashContainerDescription });
      });
      const sizes = [...sizeOptions].reduce((previousSizes, el) => {
        alternativeSizes[el.size] = el.desc;
        const filteredOptions = options.filter((item) => item.containerSize === el.size);
        const frequencyOptions: Set<Frequency> = new Set();
        filteredOptions.forEach((item) => {
          frequencyOptions.add(item.frequency);
        });
        return { ...previousSizes, [el.size]: sortFrequency([...frequencyOptions]) };
      }, {});

      return {
        items: options,
        sizes,
        quantityLimits: { min: 1, max: 2 },
        seasonDurationOptions: [3, 4, 5, 6, 7, 8, 9],
        alternativeSizes,
        optionsMatrix,
      };
    }

    return null;
  }
}
